module.exports = __webpack_public_path__ + "img/4.fcb9370.svg";